<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction.bind(this, ledgerType)"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <GcHeaderGeneralLedgerEnquiry
        :title="reportTitle"
        :baseView="baseView"
        :summaryTitle="ledgerTitles.summaryTitle"
        :accountTitle="ledgerTitles.accountTitle"
        :detailsTitle="ledgerTitles.detailsTitle"
        :ledgerType="getLedgerType"
        :backButtonFunction="backButtonFunction"
        v-if="reportTitle && loadingCompleted"
      />
    </template>

    <div class="grid-report general-ledger-report">
      <gc-filter-split-view
        :showLeftContainer="showLeftContainer"
        :showRightContainer="showRightContainer"
      >
        <template #leftContent>
          <dx-data-grid
            :data-source="dataSourceConfig"
            :hover-state-enabled="false"
            :allow-column-reordering="true"
            :reshape-on-push="true"
            :columns="columns"
            @toolbar-preparing="onToolbarPreparing($event)"
            :height="gridHeight"
            @content-ready="listContentReady"
            ref="general-ledger-report-grid"
            v-if="loadingCompleted && selectedViewType"
            @selection-changed="onSelectionChanged"
            @exporting="onGridToExcelExporting($event, saveFileName, columns)"
          >
            <DxExport :enabled="true" :file-name="saveFileName" />

            <template #account-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.AccountDescription"
                :code="data.data.AccountCode"
              />
            </template>
            ]<template #cus-sup-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.SubCodeName"
                :code="data.data.SubCode"
              />
            </template>
            ]<template #branch-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.BranchDescription"
                :code="data.data.BranchCode"
              />
            </template>
            ]<template #division-cell-template="{ data }">
              <GcDescriptionCodeCellTemplate
                :description="data.data.DivisionDescription"
                :code="data.data.DivisionCode"
              />
            </template>

            <template #filterLable="{ data }">
              <div class="filterLable" v-if="model.DisplayFiscalMonth">
                <span class="name">{{
                  model.DisplayFiscalMonth.toLowerCase() +
                    " " +
                    model.DisplayFiscalYear
                }}</span>
              </div>
            </template>

            <template #number-cell-template="{ data }">
              <gc-grid-value-format :dataValue="data" />
            </template>

            <DxSummary>
              <DxTotalItem
                column="OpeningBalance"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="OpeningBalanceTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType != 'GLEnquiryIncomeExpense'"
                column="PeriodMovement"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="PeriodMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                column="ClosingBalance"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="ClosingBalanceTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="MTDBudget"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="MTDBudgetTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="ThisYearMTDMovement"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="ThisYearMTDMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="LastYearMTDMovement"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="LastYearMTDMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="YTDBudget"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="YTDBudgetTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="ThisYearYTDMovement"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="ThisYearYTDMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryIncomeExpense'"
                column="LastYearYTDMovement"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="LastYearYTDMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
              <DxTotalItem
                v-if="selectedViewType == 'GLEnquiryMovement'"
                column="Amount"
                summary-type="sum"
                :value-format="getDecimalFormatByName('Decimal-4-2C').Format"
                name="DetailsMovementTotal"
                display-format="{0}"
                :customizeText="customizeText"
              />
            </DxSummary>
          </dx-data-grid>
        </template>

        <template #rightContent>
          <gc-advance-filter-panel
            :toolbar="filterToolbar"
            :filterFormHeight="filterFormHeight"
            :advanceFilterArray="advanceFilterArray"
            :filterCallBack="createFilterArray"
            :sideBarTabs="sideBarTabs"
            :filterFormItems="filterFormItems"
            :filterModel="getAdvanceFilterModel"
            :isJson="false"
            :applyFilter="applyFilter"
            :dirty.sync="filterDirty"
            v-if="model.FiscalPeriodDefault"
          >
          </gc-advance-filter-panel>
        </template>
      </gc-filter-split-view>
    </div>

    <!-- <template #footer v-if="rightSideValues.length != 0">
      <RpGridFooter
        :CurrencyCode="model.CurrencyCode"
        :leftSideValue="leftSideValue"
        :rightSideValues="rightSideFooterValues"
      />
    </template> -->
  </gc-main-layout>
</template>

<script>
/* eslint-disable no-console */
import BaseViewMixin from "../../v1/_mixins/base.view";
import { GridReportService } from "../../_services/api/reports/grid-report.service";
import { DxSummary, DxExport, DxTotalItem } from "devextreme-vue/data-grid";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {
    DxExport,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      advanceFilterArray: [],
      reportTitle: undefined,
      dataSourceConfig: [],
      showLeftContainer: true,
      showRightContainer: false,
      filterDirty: { isDirty: false },
      filterToolbar: {
        close: {
          icon: "showpanel",
          onClick: () => {
            this.showRightContainer = !this.showRightContainer;
            var item = document.getElementById("filter-btn");
            item.classList.remove("dx-state-invisible");
          },
        },
      },
      filterFormHeight: "auto",
      sideBarTabs: [
        {
          id: 0,
          text: "Filters",
        },
      ],
      saveFileName: "General Ledger Enquiry - Summary",

      viewTypes: [
        {
          value: "GLEnquiryTrialBalance",
          text: "Trial Balance",
          selected: true,
        },
        {
          value: "GLEnquiryAssetLiability",
          text: "Balance Sheet",
          selected: false,
        },
        {
          value: "GLEnquiryIncomeExpense",
          text: "Profit & Loss",
          selected: false,
        },
      ],
      selectedViewType: undefined,
      displayLabel: "Month and Fiscal Year",
      model: {
        FiscalYear: undefined,
        FiscalMonth: undefined,
        FiscalPeriod: undefined,
        FiscalPeriodDefault: undefined,
        FiscalPeriods: [],
        DisplayFiscalYear: undefined,
        DisplayFiscalMonth: undefined,
        GetCalYear: undefined,
      },
      leftSideValue: [],
      rightSideValues: [],
      OpeningBalanceTotal: 0,
      PeriodMovementTotal: 0,
      ClosingBalanceTotal: 0,
      MTDBudgetTotal: 0,
      ThisYearMTDMovementTotal: 0,
      LastYearMTDMovementTotal: 0,
      YTDBudgetTotal: 0,
      ThisYearYTDMovementTotal: 0,
      LastYearYTDMovementTotal: 0,
      DetailsMovementTotal: 0,
      ledgerType: "summary",
      ledgerTitles: {
        summaryTitle: undefined,
        accountTitle: undefined,
        detailsTitle: undefined,
      },
      summaryReportAdvanceFilter: [],
      accountReportAdvanceFilter: [],
      detailsReportAdvanceFilter: [],
      advanceFilterModel: {
        BranchCode: [],
        FiscalYear: undefined,
        FiscalPeriod: undefined,
      },
      SubCodeLabel: "",
      SubCodeVisible: true,
    };
  },
  async created() {
    this.showLoading(true);
    this.ledgerType = this.baseView.id;
    await this.setDefaultFilter();

    if (this.baseView.query.filter) {
      this.advanceFilterArray = JSON.parse(this.baseView.query.filter);
      this.selectedViewType = JSON.parse(this.baseView.query.view_type);
      this.filterReCreate();
    } else {
      this.selectedViewType = "GLEnquiryTrialBalance";
    }
    this.reportTitle = "General Ledger Enquiry";
  },
  methods: {
    customizeText(e) {
      var pattern = /[-]/g;
      if (pattern.test(e.valueText)) {
        var x = e.valueText.split(" ");
        if (parseFloat(x[1]) == 0) {
          return "$ 0.00";
        } else {
          return e.valueText;
        }
      } else {
        return e.valueText;
      }
    },
    async onSelectionChanged(e) {
      this.ledgerTitles.summaryTitle =
        this.model.DisplayFiscalMonth.toLowerCase() +
        " " +
        this.model.DisplayFiscalYear;

      if (this.ledgerType == "summary") {
        if (
          this.advanceFilterArray[this.advanceFilterArray.length - 1] != "and"
        )
          this.advanceFilterArray.push("and");
        this.advanceFilterArray.push([
          ["AccountCode", "=", e.selectedRowKeys[0].AccountCode],
        ]);

        this.ledgerType = "account";

        this.selectedViewType = "GLEnquiryAccountDetail";
        this.ledgerTitles.accountTitle =
          e.selectedRowKeys[0].AccountCode +
          " - " +
          e.selectedRowKeys[0].AccountDescription;
        this.$router
          .push({
            path: "/report/general-ledger/account",
            query: {
              filter: JSON.stringify(this.advanceFilterArray),
              view_type: JSON.stringify(this.selectedViewType),
            },
          })
          .then(() => {
            this.loadingCompleted = true;
          });
      } else if (this.ledgerType == "account") {
        if (
          this.advanceFilterArray[this.advanceFilterArray.length - 1] != "and"
        )
          this.advanceFilterArray.push("and");
        this.advanceFilterArray.push([
          ["TransactionType", "=", e.selectedRowKeys[0].TransactionType],
        ]);

        this.ledgerType = "details";

        this.selectedViewType = "GLEnquiryMovement";
        this.ledgerTitles.detailsTitle =
          e.selectedRowKeys[0].TransactionTypeDescription;
        this.$router
          .push({
            path: "/report/general-ledger/details",
            query: {
              filter: JSON.stringify(this.advanceFilterArray),
              view_type: JSON.stringify(this.selectedViewType),
              account_title: JSON.stringify(this.ledgerTitles.accountTitle),
            },
          })
          .then(() => {
            this.loadingCompleted = true;
          });
      }
    },
    async resetFilterParams() {
      let filterFields = this.filterFormItems[0].items.filter((x) => {
        return x.visible != false;
      });

      await filterFields.forEach(async (element) => {
        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          element.dataField
        );
        if (this.advanceFilterModel[element.dataField])
          if (this.advanceFilterModel[element.dataField].length > 0)
            this.advanceFilterModel[element.dataField] = [];
          else if (
            element.dataField != "FiscalPeriod" &&
            element.dataField != "FiscalYear"
          )
            this.advanceFilterModel[element.dataField] = null;
      });
    },
    async setDefaultFilter() {
      this.model.FiscalYear = new Date().getFullYear();
      await GridReportService.requestData({
        url: "api/GLEnquiryFiscalPeriod",
      })
        .then((FiscalPeriod) => {
          this.model.FiscalPeriods = FiscalPeriod.data.value;
          FiscalPeriod.data.value.forEach((element) => {
            if (element.IsCurrent) {
              this.model.FiscalMonth = element.Month;
              this.model.FiscalPeriod = element.Period;
              this.model.FiscalPeriodDefault = element.Period;
            }
          });
        })
        .catch((error) => {
          if (error) this.model.FiscalPeriod = 1;
        });

      this.advanceFilterArray.push([
        ["FiscalYear", "=", this.model.FiscalYear],
        "and",
        ["FiscalPeriod", "=", this.model.FiscalPeriod],
      ]);

      this.model.DisplayFiscalYear = this.model.FiscalYear;
      this.model.DisplayFiscalMonth = this.model.FiscalMonth;
    },
    getShortMonthString(month) {
      return this.months[month];
    },
    async getReportData(url, filterCollection) {
      if (this.ledgerType == "details") await this.setSubCodeLabel();
      let ds = GridReportService.dataSourceConfig("api/" + url, {
        count: true,
        filter: filterCollection,
        preventPagination: true,
      });
      await ds.load();
      this.dataSourceConfig = ds.items();

      // this.dataSourceConfig = ds.items();
      this.showLoading(false);
      this.loadingCompleted = true;

      if (this.ledgerType == "account") {
        this.dataSourceConfig.forEach((element) => {
          this.ledgerTitles.accountTitle =
            element.AccountCode + " - " + element.AccountDescription;
          return;
        });
      } else if (this.ledgerType == "details") {
        this.dataSourceConfig.forEach((element) => {
          this.ledgerTitles.detailsTitle = element.TransactionTypeDescription;
          return;
        });
        this.ledgerTitles.accountTitle = JSON.parse(
          this.baseView.query.account_title
        );
      }
      this.ledgerTitles.summaryTitle =
        this.model.DisplayFiscalMonth.toLowerCase() +
        " " +
        this.model.DisplayFiscalYear;
    },
    listContentReady(e) {
      this.filterFormHeight =
        document.getElementsByClassName("dx-datagrid dx-gridbase-container")[0]
          .clientHeight -
        document.getElementsByClassName("dx-datagrid-header-panel")[0]
          .clientHeight -
        30;

      this.addGridNoResults(e);

      if (
        this.selectedViewType == "GLEnquiryTrialBalance" ||
        this.selectedViewType == "GLEnquiryAssetLiability"
      ) {
        this.OpeningBalanceTotal = e.component.getTotalSummaryValue(
          "OpeningBalanceTotal"
        );
        this.PeriodMovementTotal = e.component.getTotalSummaryValue(
          "PeriodMovementTotal"
        );
        this.ClosingBalanceTotal = e.component.getTotalSummaryValue(
          "ClosingBalanceTotal"
        );
      } else if (this.selectedViewType == "GLEnquiryAccountDetail") {
        this.PeriodMovementTotal = e.component.getTotalSummaryValue(
          "PeriodMovementTotal"
        );
      } else if (this.selectedViewType == "GLEnquiryMovement") {
        this.DetailsMovementTotal = e.component.getTotalSummaryValue(
          "DetailsMovementTotal"
        );
      } else {
        this.OpeningBalanceTotal = e.component.getTotalSummaryValue(
          "OpeningBalanceTotal"
        );
        this.ClosingBalanceTotal = e.component.getTotalSummaryValue(
          "ClosingBalanceTotal"
        );
        this.MTDBudgetTotal = e.component.getTotalSummaryValue(
          "MTDBudgetTotal"
        );
        this.ThisYearMTDMovementTotal = e.component.getTotalSummaryValue(
          "ThisYearMTDMovementTotal"
        );
        this.LastYearMTDMovementTotal = e.component.getTotalSummaryValue(
          "LastYearMTDMovementTotal"
        );
        this.YTDBudgetTotal = e.component.getTotalSummaryValue(
          "YTDBudgetTotal"
        );
        this.ThisYearYTDMovementTotal = e.component.getTotalSummaryValue(
          "ThisYearYTDMovementTotal"
        );
        this.LastYearYTDMovementTotal = e.component.getTotalSummaryValue(
          "LastYearYTDMovementTotal"
        );
      }

      console.log("OpeningBalanceTotal 1", this.OpeningBalanceTotal);
      this.caclulateFooterValues();
    },
    async createFilterArray(filterCollection, filterField, e) {
      if (filterCollection.length != 0) {
        if (filterField == "FiscalYear" || filterField == "FiscalPeriod") {
          if (filterField == "FiscalYear") this.model.FiscalYear = e.value;
          else this.model.FiscalPeriod = e.value;

          if (filterField == "FiscalPeriod") {
            var getMonthString = this.model.FiscalPeriods.filter((item) => {
              return item.Period == this.model.FiscalPeriod;
            });

            if (getMonthString)
              this.model.FiscalMonth = getMonthString[0].Month;
          }
        }

        filterCollection = await this.removeFromAdvanceFilter(
          filterCollection,
          "FiscalYear"
        );
        filterCollection = await this.removeFromAdvanceFilter(
          filterCollection,
          "FiscalPeriod"
        );

        filterCollection.push([
          ["FiscalYear", "=", this.model.FiscalYear],
          "and",
          ["FiscalPeriod", "=", this.model.FiscalPeriod],
        ]);

        if (e.value == null || e.value.length == 0) {
          if (this.advanceFilterModel[filterField])
            if (this.advanceFilterModel[filterField].length > 0)
              this.advanceFilterModel[filterField] = [];
            else this.advanceFilterModel[filterField] = null;

          this.advanceFilterArray = await this.removeFromAdvanceFilter(
            this.advanceFilterArray,
            filterField
          );
        }

        this.advanceFilterArray = filterCollection;
      }
    },
    async applyFilter(type, filterCollection) {
      console.log("this.advanceFilterArray ", this.advanceFilterArray);

      // to skip the compile warn msg
      if (filterCollection) {
        this.$logger.debug(filterCollection);
      }

      this.showLoading(true);
      if (type == "clear") {
        await this.resetFilterParams();
        await this.setDefaultFilter();
      }
      this.$router
        .push({
          path: "/report/general-ledger/" + this.baseView.id,
          query: {
            filter: JSON.stringify(this.advanceFilterArray),
            view_type: JSON.stringify(this.selectedViewType),
          },
        })
        .then(() => {
          this.routingCompleted();
        })
        .catch(() => {
          this.loadingCompleted = true;
          this.showLoading(false);
        });
    },
    async removeFromAdvanceFilter(filterArray, dataField) {
      if (filterArray.length != 0) {
        if (filterArray.length > 0) {
          let index = filterArray.findIndex((x) => x[0][0] == dataField);
          if (index > -1) {
            if (filterArray[index + 1] == "and") {
              filterArray.splice(index, 2);
            } else {
              filterArray.splice(index, 1);
            }
          }
          // after the splice event

          if (
            filterArray.length > 0 &&
            filterArray[filterArray.length - 1] != "and"
          )
            filterArray.push("and");
        }
      }

      return filterArray;
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });
      var exportButton = toolbarItems.find((item) => {
        return item.name === "exportButton";
      });
      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });
      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" &&
          item.name !== "exportButton" &&
          item.name !== "columnChooserButton"
        );
      });
      searchPanel.location = "after";
      columnChooserButton.visible = this.ledgerType == "details";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            width: 150,
            items: this.viewTypes,
            displayExpr: "text",
            valueExpr: "value",
            value: this.selectedViewType,
            onValueChanged: (e) => {
              this.selectedViewType = e.value;
            },
            visible: this.ledgerType == "summary",
          },
        },
        {
          location: "before",
          template: "filterLable",
          visible: this.ledgerType == "summary",
        },
        searchPanel,
        exportButton,
        columnChooserButton,
        {
          location: "after",
          locateinmenu: "auto",
          widget: "dxButton",
          options: {
            validationGroup: "formsData",
            icon: "filter",
            elementAttr: { id: "filter-btn" },
            visible: !this.showRightContainer,
            onClick: () => {
              this.showRightContainer = !this.showRightContainer;
              var item = document.getElementById("filter-btn");
              this.$logger.debug("item ", item);
              item.classList.add("dx-state-invisible");

              var grid = this.$refs["general-ledger-report-grid"].instance;
              grid.repaint();

              this.loadingCompleted = false;
              setTimeout(() => {
                this.loadingCompleted = true;
              }, 50);
            },
          },
        }
      );
    },
    async backButtonFunction(ledgerType) {
      if (ledgerType == "account") {
        this.ledgerType = "summary";

        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          "AccountCode"
        );
        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          "TransactionType"
        );
        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          "SubCode"
        );
        this.selectedViewType = "GLEnquiryTrialBalance";

        this.$router
          .push({
            path: "/report/general-ledger/summary",
            query: {
              filter: JSON.stringify(this.advanceFilterArray),
              view_type: JSON.stringify(this.selectedViewType),
            },
          })
          .then(() => {
            this.loadingCompleted = true;
            this.filterReCreate();
          });
      } else if (ledgerType == "details") {
        this.ledgerType = "account";
        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          "TransactionType"
        );
        this.advanceFilterArray = await this.removeFromAdvanceFilter(
          this.advanceFilterArray,
          "SubCode"
        );
        this.selectedViewType = "GLEnquiryAccountDetail";
        this.$router
          .push({
            path: "/report/general-ledger/account",
            query: {
              filter: JSON.stringify(this.advanceFilterArray),
              view_type: JSON.stringify(this.selectedViewType),
            },
          })
          .then(() => {
            this.loadingCompleted = true;
            this.filterReCreate();
          });
      } else {
        this.$router.push({
          path: "/reports/general-ledger",
        });
      }
    },
    caclulateFooterValues() {
      this.rightSideValues = [];
      if (
        this.selectedViewType == "GLEnquiryTrialBalance" ||
        this.selectedViewType == "GLEnquiryAssetLiability"
      ) {
        this.rightSideValues.push(
          {
            id: 1,
            title: "Opening Balance",
            value: this.OpeningBalanceTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 2,
            title: "Movement",
            value: this.PeriodMovementTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 3,
            title: "Closing Balance",
            value: this.ClosingBalanceTotal,
            format: "Decimal-6-2C",
            length: 7,
          }
        );
      } else if (this.selectedViewType == "GLEnquiryIncomeExpense") {
        this.rightSideValues.push(
          {
            id: 1,
            title: "Opening Balance",
            value: this.OpeningBalanceTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 2,
            title: "Closing Balance",
            value: this.ClosingBalanceTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 3,
            title: "MTD Budget",
            value: this.MTDBudgetTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 4,
            title: this.ThisYearMTDMovementLabel,
            value: this.ThisYearMTDMovementTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 5,
            title: this.LastYearMTDMovementLabel,
            value: this.LastYearMTDMovementTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 6,
            title: "YTD Budget",
            value: this.YTDBudgetTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 7,
            title: this.ThisYearYTDMovementLabel,
            value: this.ThisYearYTDMovementTotal,
            format: "Decimal-6-2C",
            length: 7,
          },
          {
            id: 8,
            title: this.LastYearYTDMovementLabel,
            value: this.LastYearYTDMovementTotal,
            format: "Decimal-6-2C",
            length: 7,
          }
        );
      } else if (this.selectedViewType == "GLEnquiryAccountDetail") {
        this.rightSideValues.push({
          id: 1,
          title: "Movement",
          value: this.PeriodMovementTotal,
          format: "Decimal-6-2C",
          length: 7,
        });
      } else if (this.selectedViewType == "GLEnquiryMovement") {
        this.rightSideValues.push({
          id: 1,
          title: "Movement",
          value: this.DetailsMovementTotal,
          format: "Decimal-6-2C",
          length: 7,
        });
      }
    },
    async filterReCreate() {
      let filterFields = this.filterFormItems[0].items.filter((x) => {
        return x.visible != false;
      });

      filterFields.forEach((element) => {
        let index = this.advanceFilterArray.findIndex((x) => {
          if (x.length > 1) {
            for (let i = 0; i < x.length; i++) {
              if (x[i][0] == element.dataField) return x;
            }
          } else {
            return x[0][0] == element.dataField;
          }
        });

        if (index > -1) {
          if (this.advanceFilterArray[index].length > 0) {
            this.advanceFilterModel[element.dataField] = [];
            for (let x = 0; x < this.advanceFilterArray[index].length; x++) {
              if (Array.isArray(this.advanceFilterArray[index][x])) {
                if (
                  element.dataField == "FiscalYear" ||
                  element.dataField == "FiscalPeriod" ||
                  element.dataField == "TransactionReference" ||
                  element.dataField == "Comment" ||
                  element.dataField == "TransactionType"
                ) {
                  if (
                    element.dataField == this.advanceFilterArray[index][x][0]
                  ) {
                    this.advanceFilterModel[
                      element.dataField
                    ] = this.advanceFilterArray[index][x][2];
                    if (element.dataField == "FiscalYear") {
                      this.model.FiscalYear = this.advanceFilterArray[index][
                        x
                      ][2];
                    } else if (element.dataField == "FiscalPeriod") {
                      this.model.FiscalPeriod = this.advanceFilterArray[index][
                        x
                      ][2];
                      var getMonthString = this.model.FiscalPeriods.filter(
                        (item) => {
                          return item.Period == this.model.FiscalPeriod;
                        }
                      );

                      if (getMonthString)
                        this.model.FiscalMonth = getMonthString[0].Month;
                    } else {
                      // console.log('AAA ', this.advanceFilterArray[index][x]);
                    }

                    console.log("BBB ", this.advanceFilterModel);
                  }
                } else {
                  for (
                    let y = 0;
                    y < this.advanceFilterArray[index][x].length;
                    y++
                  ) {
                    this.advanceFilterModel[element.dataField].push(
                      this.advanceFilterArray[index][x][2]
                    );
                    break;
                  }
                }
              }
            }
          }
        }
      });
      // this.model.DisplayFiscalYear = this.model.FiscalYear;
      this.model.DisplayFiscalMonth = this.model.FiscalMonth;

      await GridReportService.requestData({
        url: "api/ReportFiscalPeriod",
        filter: `FiscalYear eq ${this.model.FiscalYear} and ThisFiscalPeriod eq ${this.model.FiscalPeriod}`,
      }).then((res) => {
        this.model.DisplayFiscalYear = res.data.value[0].Year;
      });
    },
    async setSubCodeLabel() {
      let index = this.advanceFilterArray.findIndex(
        (x) => x[0][0] == "TransactionType"
      );
      await GridReportService.requestData({
        url: "api/GLEnquiryTransactionType",
        filter: `TransactionType eq '${this.advanceFilterArray[index][0][2]}'`,
      }).then((item) => {
        var type = item.data.value[0].TransactionTypeDescription;

        if (
          type == "Customer Invoice" ||
          type == "Cash Receipt" ||
          type == "Sundry Receipt"
        ) {
          this.SubCodeLabel = "Customer";
          this.SubCodeVisible = true;
        } else if (
          type == "Cash Payment" ||
          type == "Sundry Payment" ||
          type == "Goods In" ||
          type == "Supplier Invoice"
        ) {
          this.SubCodeLabel = "Supplier";
          this.SubCodeVisible = true;
        } else {
          this.SubCodeVisible = false;
        }
      });
    },
    async routingCompleted() {
      this.advanceFilterArray = JSON.parse(this.baseView.query.filter);
      await this.filterReCreate();
      await this.getReportData(this.selectedViewType, this.advanceFilterArray);

      this.loadingCompleted = true;
      this.showLoading(false);
    },
  },
  computed: {
    getAdvanceFilterModel() {
      return this.advanceFilterModel;
    },
    getLedgerType() {
      return this.ledgerType;
    },
    filterFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: this.parseFormColumns([
            {
              dataField: "FiscalYear",
              gcType: "String",
              gcLabel: "Fiscal Year",
              editorType: "dxSelectBox",
              visible: this.ledgerType == "summary",
              editorOptions: {
                editorType: "dxSelectBox",
                dataSource: GridReportService.dataSourceConfig(
                  "api/GLEnquiryFiscalYear",
                  {}
                ),
                valueExpr: "Year",
                displayExpr: "Year",
                primaryText: "Year",
                secondaryText: null,
                onInitialized: (e) => {
                  e.component.beginUpdate();
                  if (!this.advanceFilterModel.FiscalYear)
                    e.component.option("value", new Date().getFullYear());
                  e.component.endUpdate();
                },
              },
            },
            {
              dataField: "FiscalPeriod",
              gcType: "String",
              gcLabel: "Fiscal Month",
              editorType: "dxSelectBox",
              visible: this.ledgerType == "summary",
              editorOptions: {
                editorType: "dxSelectBox",
                dataSource: GridReportService.dataSourceConfig(
                  "api/ReportFiscalPeriod",
                  {
                    filter: ["FiscalYear", "=", this.model.FiscalYear],
                  }
                ),
                valueExpr: "ThisFiscalPeriod",
                displayExpr: function(data) {
                  if (data) return data.Month.toProperCase();
                },
                onInitialized: (e) => {
                  e.component.beginUpdate();
                  if (!this.advanceFilterModel.FiscalPeriod)
                    e.component.option("value", this.model.FiscalPeriodDefault);
                  e.component.endUpdate();
                },
              },
            },
            {
              dataField: "BranchCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Branch",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Branch", {
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "DivisionCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Division",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/Division", {
                  select: ["Code", "Description"],
                  filter: [["Inactive", "=", "N"]],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["Code", "Description"],
                searchMode: "contains",
                showClearButton: true,
                searchEnabled: true,
                editorType: "dxTagBox",
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "AccountCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcLabel: "Account",
              visible: this.ledgerType == "summary",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig("api/GLChart", {
                  select: ["Code", "Description", "ComputedStringCode"],
                  sort: [{ selector: "Description", asc: true }],
                }),
                valueExpr: "Code",
                displayExpr: "Description",
                searchExpr: ["ComputedStringCode", "Description"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "item-template",
              },
            },
            {
              dataField: "TransactionType",
              gcType: "String",
              editorType: "dxSelectBox",
              gcLabel: "Transaction Type",
              visible: this.ledgerType != "details",
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/GLEnquiryTransactionType",
                  {
                    select: ["TransactionType", "TransactionTypeDescription"],
                    sort: [
                      { selector: "TransactionTypeDescription", asc: true },
                    ],
                  }
                ),
                valueExpr: "TransactionType",
                displayExpr: "TransactionTypeDescription",
                searchExpr: ["TransactionType", "TransactionTypeDescription"],
                searchMode: "contains",
                searchEnabled: true,
                itemTemplate: "transaction-type-template",
                showClearButton: true,
              },
            },
            {
              dataField: "TransactionReference",
              gcType: "String",
              editorType: "dxTextBox",
              gcLabel: "Transaction Reference",
              editorOptions: {
                showClearButton: true,
                editorType: "dxTextBox",
              },
            },
            {
              dataField: "SubCode",
              gcType: "String",
              editorType: "dxTagBox",
              gcDynamicLabel: this.getSubCodeLabel,
              visible: this.ledgerType == "details" && this.SubCodeVisible,
              editorOptions: {
                dataSource: GridReportService.dataSourceConfig(
                  "api/GLEnquirySubCode",
                  {
                    select: ["Code", "Name"],
                    sort: [{ selector: "Name", asc: true }],
                  }
                ),
                valueExpr: "Code",
                displayExpr: "Name",
                searchExpr: ["Code", "Name"],
                searchMode: "contains",
                searchEnabled: true,
                showClearButton: true,
                itemTemplate: "sub-code-template",
              },
            },
            // {
            //   dataField: "Comment",
            //   gcType: "String",
            //   editorType: "dxTextBox",
            //   gcLabel: "Comment",
            //   visible: this.ledgerType == "details",
            //   editorOptions: {
            //     showClearButton: true,
            //     editorType: "dxTextBox",
            //   },
            // },
          ]),
        },
      ];
    },
    rightSideFooterValues() {
      return this.rightSideValues;
    },
    columns() {
      var columnArray = [];
      if (this.ledgerType == "summary") {
        if (
          this.selectedViewType == "GLEnquiryTrialBalance" ||
          this.selectedViewType == "GLEnquiryAssetLiability"
        ) {
          columnArray = JSON.parse(
            JSON.stringify(this.GLEnquiryTrialBalanceColumns)
          );
        } else
          columnArray = JSON.parse(
            JSON.stringify(this.GLEnquiryIncomeExpenseColumns)
          );
      } else if (this.ledgerType == "account") {
        columnArray = JSON.parse(
          JSON.stringify(this.GLEnquiryAccountDetailColumns)
        );
      } else if (this.ledgerType == "details") {
        columnArray = JSON.parse(JSON.stringify(this.GLEnquiryMovementColumns));
      }

      return this.parseGridColumns("master", columnArray);
    },
    GLEnquiryTrialBalanceColumns() {
      return [
        {
          gcLabel: "Account",
          dataField: "AccountCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: "asc",
          cellTemplate: "account-cell-template",
          gcExport: ["AccountCode", "AccountDescription"],
        },
        {
          gcLabel: "Account Code",
          dataField: "AccountCode",
          gcSubType: "HiddenCode",
          gcType: "String",
          width: 120,
          showInColumnChooser: false,
        },
        {
          gcLabel: "Account Description",
          dataField: "AccountDescription",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
          allowExporting: true,
        },
        {
          gcLabel: "Type",
          dataField: "AccountTypeDescription",
          gcType: "String",
          width: 200,
        },
        {
          gcLabel: "Month",
          dataField: "MonthAndYear",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Opening Balance",
          dataField: "OpeningBalance",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Movement",
          dataField: "PeriodMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Closing Balance",
          dataField: "ClosingBalance",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
      ];
    },
    GLEnquiryIncomeExpenseColumns() {
      return [
        {
          gcLabel: "Account",
          dataField: "AccountCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: "asc",
          cellTemplate: "account-cell-template",
          gcExport: ["AccountCode", "AccountDescription"],
        },
        {
          gcLabel: "Account Code",
          dataField: "AccountCode",
          gcSubType: "HiddenCode",
          gcType: "String",
          width: 120,
          showInColumnChooser: false,
        },
        {
          gcLabel: "Account Description",
          dataField: "AccountDescription",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Type",
          dataField: "AccountTypeDescription",
          gcType: "String",
          width: 170,
        },
        {
          gcLabel: "Month",
          dataField: "MonthAndYear",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Opening Balance",
          dataField: "OpeningBalance",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "Closing Balance",
          dataField: "ClosingBalance",
          gcType: "Decimal-8-2C-RO",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "MTD Budget",
          dataField: "MTDBudget",
          gcType: "Decimal-8-2C-RO",
          allowResizing: false,
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.ThisYearMTDMovementLabel,
          dataField: "ThisYearMTDMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.LastYearMTDMovementLabel,
          dataField: "LastYearMTDMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcLabel: "YTD Budget",
          dataField: "YTDBudget",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.ThisYearYTDMovementLabel,
          dataField: "ThisYearYTDMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
        {
          gcDynamicLabel: this.LastYearYTDMovementLabel,
          dataField: "LastYearYTDMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
      ];
    },
    ThisYearMTDMovementLabel() {
      return `MTD (${this.model.DisplayFiscalYear})`;
    },
    LastYearMTDMovementLabel() {
      return `MTD (${this.model.DisplayFiscalYear - 1})`;
    },
    ThisYearYTDMovementLabel() {
      return `YTD (${this.model.DisplayFiscalYear})`;
    },
    LastYearYTDMovementLabel() {
      return `YTD (${this.model.DisplayFiscalYear - 1})`;
    },
    GLEnquiryAccountDetailColumns() {
      return [
        {
          gcLabel: "Account",
          dataField: "AccountCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: null,
          cellTemplate: "account-cell-template",
          gcExport: ["AccountCode", "AccountDescription"],
        },
        {
          gcLabel: "Account Code",
          dataField: "AccountCode",
          gcSubType: "HiddenCode",
          gcType: "String",
          width: 120,
          showInColumnChooser: false,
        },
        {
          gcLabel: "Account Description",
          dataField: "AccountDescription",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Month",
          dataField: "MonthAndYear",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Transaction Type",
          dataField: "TransactionTypeDescription",
          gcType: "String",
          width: 150,
          sortOrder: "asc",
        },
        {
          gcLabel: "Movement",
          dataField: "PeriodMovement",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
      ];
    },
    GLEnquiryMovementColumns() {
      return [
        {
          gcLabel: "Account",
          dataField: "AccountCode",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: null,
          cellTemplate: "account-cell-template",
          gcExport: ["AccountCode", "AccountDescription"],
        },
        {
          gcLabel: "Account Code",
          dataField: "AccountCode",
          gcSubType: "HiddenCode",
          gcType: "String",
          width: 120,
          showInColumnChooser: false,
        },
        {
          gcLabel: "Account Description",
          dataField: "AccountDescription",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Month",
          dataField: "MonthAndYear",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Type",
          dataField: "TransactionTypeDescription",
          gcType: "String",
          width: 150,
        },
        {
          gcLabel: "Transaction",
          dataField: "TransactionNo",
          gcType: "String",
          width: 150,
          sortOrder: "asc",
        },
        {
          gcDynamicLabel: this.getSubCodeLabel,
          dataField: "SubCode",
          gcType: "String",
          cellTemplate: "cus-sup-cell-template",
          gcExport: ["SubCode", "SubCodeName"],
          width: 200,
          visible: this.SubCodeVisible,
        },
        {
          gcDynamicLabel: this.getSubCodeLabel + " Code",
          dataField: "SubCode",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcDynamicLabel: this.getSubCodeLabel + " Name",
          dataField: "SubCodeName",
          gcType: "String",
          minWidth: this.gridColumnMinWidth(300),
          gcSubType: "HiddenDescription",
          showInColumnChooser: false,
        },
        {
          gcLabel: "Branch",
          dataField: "BranchCode",
          gcType: "String",
          // cellTemplate: "branch-cell-template",
          // gcExport: ["BranchCode", "BranchDescription"],
          width: 100,
        },
        {
          gcLabel: "Division",
          dataField: "DivisionCode",
          gcType: "String",
          // cellTemplate: "division-cell-template",
          // gcExport: ["DivisionCode", "DivisionDescription"],
          width: 100,
        },
        {
          gcLabel: "Line No",
          dataField: "TransactionLineNo",
          gcType: "Decimal-TransactionNo",
        },
        {
          gcLabel: "Comment",
          dataField: "Comment",
          gcType: "String",
          width: 200,
        },
        {
          gcLabel: "Movement",
          dataField: "Amount",
          gcType: "Decimal-8-2C-RO",
          cellTemplate: "number-cell-template",
        },
      ];
    },
    getSubCodeLabel() {
      return this.SubCodeLabel;
    },
  },
  watch: {
    selectedViewType() {
      this.showLoading(true);
      this.loadingCompleted = false;
      this.getReportData(this.selectedViewType, this.advanceFilterArray);
    },
    showRightContainer(newVal) {
      if (!newVal) {
        this.loadingCompleted = false;
        setTimeout(() => {
          this.loadingCompleted = true;
        }, 50);
      }
    },
    // loadingCompleted() {
    //   console.log("loadingCompleted ", this.loadingCompleted);
    // },
    OpeningBalanceTotal(val) {
      console.log("OpeningBalanceTotal ", val);
    },
  },
  destroyed() {},
};
</script>

<style lang="scss"></style>
